import { Color } from './color.model';

export class Canvas {
  private _canvas: HTMLCanvasElement;
  private _ctx: CanvasRenderingContext2D;

  get canvas(): HTMLCanvasElement {
    return this._canvas;
  }

  get ctx(): CanvasRenderingContext2D {
    return this._ctx;
  }

  //function to implement background-size: cover in Canvas
  static drawImageProp(ctx, img, x, y, w, h, offsetX, offsetY) {

      if (arguments.length === 2) {
        x = y = 0;
        w = ctx.canvas.width;
        h = ctx.canvas.height;
      }

      /// default offset is center
      offsetX = offsetX ? offsetX : 0.5;
      offsetY = offsetY ? offsetY : 0.5;

      /// keep bounds [0.0, 1.0]
      if (offsetX < 0) offsetX = 0;
      if (offsetY < 0) offsetY = 0;
      if (offsetX > 1) offsetX = 1;
      if (offsetY > 1) offsetY = 1;

      let iw = img.width,
        ih = img.height,
        r = Math.min(w / iw, h / ih),
        nw = iw * r, /// new prop. width
        nh = ih * r, /// new prop. height
        cx, cy, cw, ch, ar = 1;

      /// decide which gap to fill
      if (nw < w) ar = w / nw;
      if (nh < h) ar = h / nh;
      nw *= ar;
      nh *= ar;

      /// calc source rectangle
      cw = iw / (nw / w);
      ch = ih / (nh / h);

      cx = (iw - cw) * offsetX;
      cy = (ih - ch) * offsetY;

      /// make sure source rectangle is valid
      if (cx < 0) cx = 0;
      if (cy < 0) cy = 0;
      if (cw > iw) cw = iw;
      if (ch > ih) ch = ih;

      /// fill image in dest. rectangle
      ctx.drawImage(img, cx, cy, cw, ch, x, y, w, h);

  }
  constructor(width: number, height: number, nativeCanvas?: HTMLCanvasElement) {
    if (nativeCanvas) {
      this._canvas = nativeCanvas;
      this.setCanvasSize(nativeCanvas.width, nativeCanvas.height);
      this._ctx = this._canvas.getContext("2d");
    } else {
      this._canvas = document.createElement("canvas");
      this.setCanvasSize(width, height);
      this._ctx = this._canvas.getContext("2d");
    }
  }

  private setCanvasSize(width: number, height: number) {
    this._canvas.width = width;
    this._canvas.height = height;
  }

  paint(callback: Function) {
    callback();
  }

  blendMultiplyCustom(param: Color) {
    const baseLayer = this._ctx.getImageData(0, 0,
      this.canvas.width,
      this.canvas.height
    );
    const baseLayerData = baseLayer.data;
    const baseLayerDataLength = baseLayerData.length;
    for (let i = 0; i < baseLayerDataLength; i += 4) {
      if (baseLayerData[i + 3] > 0) {
        baseLayerData[i] = baseLayerData[i] * param.R / 255;
        baseLayerData[i + 1] = baseLayerData[i + 1] * param.G / 255;
        baseLayerData[i + 2] = baseLayerData[i + 2] * param.B / 255;
      }
    }
    this._ctx.putImageData(baseLayer, 0, 0);
  }
  blendMultiply(param: Color, mask: CanvasImage) {

    this._ctx.fillStyle = `rgb(${param.R},${param.G},${param.B})`;
    this._ctx.fillRect(0, 0, this._canvas.width, this._canvas.height);

    this._ctx.globalCompositeOperation = 'destination-atop';
    this._ctx.drawImage(mask.image, 0, 0, mask.image.width, mask.image.height);

  }
  clear() {
    this._ctx.clearRect(0, 0, this._canvas.width, this._canvas.height);
  }
  colorCanvas (color: string) {
    this.ctx.fillStyle = color;
    this.ctx.fillRect(0,0, this.canvas.width, this.canvas.height );
  }
}

export class CanvasImage {
  private _image: HTMLImageElement = new Image();
  get image(): HTMLImageElement {
    return this._image;
  }

  static drawImage(img: CanvasImage, layer: Canvas) {
    layer.ctx.drawImage(img._image, 0, 0, img._image.width, img._image.height);
  }
  static drawCanvas(base: Canvas, layer: Canvas) {
    base.ctx.drawImage(
      layer.canvas,
      0,
      0,
      layer.canvas.width,
      layer.canvas.height
    );
  }

  constructor(filePath: string, callback: any) {
    this._image.onload = callback;
    this._image.crossOrigin = "Anonymous";
    this._image.src = filePath;
  }

  drawOn(layer: Canvas) {
    layer.ctx.drawImage(
      this._image,
      0,
      0,
      this._image.width,
      this._image.height
    );
  }
  drawOnCenter(layer: Canvas) {
        layer.ctx.drawImage(this.image,
        layer.canvas.width / 2 - this.image.width / 2,
        layer.canvas.height / 2 - this.image.height / 2
  );
  }

  drawOnFullScreen(layer: Canvas) {
    layer.ctx.drawImage(this._image,
    0, 0, this._image.width, this._image.height,
    0, 0, window.innerWidth, window.innerHeight);
  }
}



// WEBPACK FOOTER //
// ./src/app/models/canvas.model.ts